module.exports = __webpack_public_path__ + "static/img/5.b5bb082.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/5.png
// module id = t65W
// module chunks = 0